<template>
    <div class="form-group" :class="computedGroupClass">
        <label class="form-group__label" :class="computedLabelClass">
            {{ label }}
        </label>
        <div class="form-group__field" :class="computedFieldClass">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },

        static: {
            type: Boolean,
            default: false,
        },

        inline: {
            type: Boolean,
            default: false,
        },

        verticalCenter: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        computedGroupClass() {
            return this.static ? 'form-group--static' : '';
        },

        computedLabelClass() {
            return this.static ? 'form-group__label--static' : '';
        },

        computedFieldClass() {
            const classes = [];

            if (this.static) {
                classes.push('form-group__field--static');
            }

            if (this.inline) {
                classes.push('form-group__inline-field');

                if (this.verticalCenter) {
                    classes.push('form-group__inline-field--vertical-center');
                }
            }

            return classes.join(' ');
        },
    },
};
</script>
